import { render, staticRenderFns } from "./AlertaGrupoOcorrencias.vue?vue&type=template&id=05ab89a8&scoped=true"
import script from "./AlertaGrupoOcorrencias.vue?vue&type=script&lang=js"
export * from "./AlertaGrupoOcorrencias.vue?vue&type=script&lang=js"
import style0 from "./AlertaGrupoOcorrencias.vue?vue&type=style&index=0&id=05ab89a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ab89a8",
  null
  
)

export default component.exports